<div class="w-full --updated-border rounded-2xl pt-4">
  <div class="px-4">
    <div class="flex gap-x-[8px] items-center --skelet-child">
      <div class="rounded-full w-[48px] aspect-square" />
      <div class="w-24 h-6 rounded-lg" />
    </div>

    <div class="--skelet-child grid grid-cols-4 h-6 gap-x-2 mt-4 w-2/3">
      <div class="rounded-lg" />
      <div class="rounded-lg" />
      <div class="rounded-lg" />
      <div class="rounded-lg" />
    </div>

    <div class="mt-[30px] w-1/3 h-6 --skelet-bg rounded-lg" />

    <div class="--skelet-bg h-6 mt-4 rounded-lg" />
    <div class="--skelet-bg h-6 mt-2 rounded-lg" />
  </div>

  <div class="--skelet-bg h-[600px] mt-4 rounded-b-2xl" />
</div>
